import { createContext, useContext } from "react";

export default function createFullContext<T>(errorMessage: string) {
    const Context = createContext<T | null>(null);
    const useFullContext = () => {
        const context = useContext(Context);
        if (!context) {
            throw new Error(errorMessage);
        }
        return context;
    };
    const Provider = ({
        value,
        children,
    }: {
        value: T;
        children: React.ReactNode;
    }) => {
        return <Context.Provider value={value}>{children}</Context.Provider>;
    };

    return [Provider, useFullContext] as const;
}
